<template>
	<div>
		Vehicle RO History
	</div>
</template>

<script>
export default {
	name: 'VehicleRoHistory',
	props: {
		id: {
			type: Number,
			default: 0
		}
	}
};
</script>

<style lang="scss" scoped></style>
